import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    filters: [],
    query: null,
    searchMeta: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setFilters(state, filters) {
        state.filters = filters;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'audit-trail-meta');

        return axios
            .get(Laroute.route('franchise.audit-trail.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'audit-trail-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'audit-trail-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    exportDetail({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.product-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailTax({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.tax-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailCharge({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.charge-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailLabels({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.label-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailFuelPrice({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.fuel-price-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailPromotion({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.promotion-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailMainPricebook({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.main-pricebook-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },

    exportDetailStationPricebook({ commit, dispatch }, data) {
        startLoading(dispatch, 'audit-trail-export');

        try {
            window.location.href = Laroute.route(
                'franchise.audit-trail.station-pricebook-export-detail',
                {
                    id: data.id,
                },
            );
            endLoading(dispatch, 'audit-trail-export');
        } catch (e) {
            endLoading(dispatch, 'audit-trail-export');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/audit-trail.js